import { buildPath } from "../../../helpers/string";
import { PermissionEnum } from "../../../modules/permission/enum";
import { root } from "./root";

export const applicationPortals = {
  path: "applicant-portals",
  getLink: () => buildPath([root.path, applicationPortals.path]),
  permissions: [PermissionEnum.ENROLLMENT_MANAGEMENT_ACCESS],
};
